"use strict";
//@ts-nocheck
/*global $*/
/*global window*/
/*global document*/
/*global console*/
/*global setTimeout*/
/*global jRespond*/
/*global TYPO3*/
(function () {
    'use strict';
    var exports = {
        /**
         * Attach rating events
         */
        attachRatingEvents: function () {
            // Attache rate-with-comment (negative base rating)
            $('button[data-rate-w-comment]').on('click', function () {
                var uid = $(this).data('rate-w-comment');
                var foreignTable = $(this).data('foreign-table');
                var comment = $('#comment-item-' + uid + '-' + foreignTable).val();
                var pageId = $('body').data('page-uid');
                exports.submitRating(uid, foreignTable, 0, comment, pageId);
            });
            // Attach positive rating (direct submit)
            $('button[data-item-positive]').on('click', function () {
                var uid = $(this).data('item-positive');
                var foreignTable = $(this).data('foreign-table');
                var pageId = $('body').data('page-uid');
                exports.submitRating(uid, foreignTable, 1, '', pageId);
            });
            // Attach negative rating (show comment field)
            $('button[data-item-negative]').on('click', function () {
                var uid = $(this).data('item-negative');
                var foreignTable = $(this).data('foreign-table');
                $('#item-' + uid + '-' + foreignTable).toggle();
            });
        },
        /**
         * Submit a rating and display the success message
         *
         * @param uid The uid of the element
         * @param foreignTable The table of the element
         * @param rating Rating for this element
         * @param comment An optional comment
         * @param pageId Page ID of rating
         */
        submitRating: function (uid, foreignTable, rating, comment, pageId) {
            if (typeof ratingApiPageUrl !== 'undefined') {
                $.ajax({
                    type: 'POST',
                    url: ratingApiPageUrl,
                    data: {
                        tx_gs1rating_rating: {
                            apiAction: 'rateItem',
                            uid: parseInt(uid),
                            foreignTable: foreignTable,
                            rating: parseInt(rating),
                            comment: comment,
                            pageId: parseInt(pageId)
                        }
                    },
                    cache: false,
                    async: true,
                    // Silently ignore any failure
                    success: function (response) {
                        var alert = 'alert-' + uid + '-' + foreignTable;
                        var message = '<div class="tx-gs1rating"><div id="' + alert + '" class="alert alert--success fade in" role="alert"><div class="alert__topbar"><p>' + response.message + '</p></div></div></div>';
                        // Display success message
                        $('#rating-form-' + uid + '-' + foreignTable).replaceWith(message);
                        // Slowly hide element
                        $('#' + alert).fadeOut(4000);
                    }
                });
            }
        }
    };
    exports.attachRatingEvents();
})();
